module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/usnavyflag.50b8493.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/usnavyflag.jpg
// module id = Injp
// module chunks = 0